import { render } from "./ModalTechStack.vue?vue&type=template&id=4a8b9da5&ts=true"
import script from "./ModalTechStack.vue?vue&type=script&lang=ts"
export * from "./ModalTechStack.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__